import { render } from "./FloatingGivePointButton.vue?vue&type=template&id=662b3160&scoped=true&ts=true"
import script from "./FloatingGivePointButton.vue?vue&type=script&lang=ts"
export * from "./FloatingGivePointButton.vue?vue&type=script&lang=ts"

import "./FloatingGivePointButton.vue?vue&type=style&index=0&id=662b3160&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662b3160"]])

export default __exports__